module.exports = __webpack_public_path__ + "img/forgot-password2.f1d8d23e.png";